import { Controller } from "@hotwired/stimulus"

// Attach to a parent container. Any click on a .sidebar-field that contains
// a .toggle-switch will toggle the checkbox (unless clicking the switch itself).
// Connects to data-controller="toggle-row"
export default class extends Controller {
  click(event) {
    const row = event.target.closest(".sidebar-field")
    if (!row) return

    const toggle = row.querySelector('.toggle-switch input[type="checkbox"]')
    if (!toggle) return

    // Don't toggle if clicking the switch itself, a link, button, or input
    if (event.target.closest(".toggle-switch, a, button, input, select")) return

    if (!toggle.disabled) {
      toggle.checked = !toggle.checked
      toggle.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
